<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-form-group class="mb-0">
                    <b-button variant="primary" @click="getReport">
                        {{ $t('get_report').toUpper() }}
                    </b-button>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import LecturerReportService from "@/services/LecturerReportService"

export default {
    methods: {
        getReport() {
            LecturerReportService.getStudentReport()
                .then((response) => {
                    this._downloadFile(response,this.$t('student_report') + '.xlsx')
                    this.processing = false
                })
        }
    }
}
</script>
